<template>
  <el-dialog
    title="物流轨迹"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <div class="p20">
        <p class="f24 mb20">{{ express.expName }} {{ express.number }} <el-tag type='' v-if="express.issign==1">签收</el-tag></p>
        <el-timeline >
            <el-timeline-item
            v-for="(item, index) in express.list"
            :key="index"
            :color="index==0 ? '#1989fa' : ''"
            :timestamp="item.time">
            <!-- <el-tag >{{item.status}}</el-tag> -->
            {{item.status}}
            </el-timeline-item>
        </el-timeline>
        
    </div>
  </el-dialog>
</template>

<script>
import ExpressApi from '@/api/express.js';
export default {
  data() {
    return {
      order_id: 0,
      loading: false,
      /*左边长度*/
      formLabelWidth: "100px",
      /*是否显示*/
      dialogVisible: true,
      express: {
          expName: '',
          number: '',
      }
    };
  },
  props: ["dataModel"],
  created() {
    this.getData();
  },
  methods: {
    /*获取参数*/
    getData() {
      let self = this;
      // 取到路由带过来的参数
      const params = this.dataModel;
      ExpressApi.getExpressTrack(params)
        .then((res) => {
          self.loading = false;
          self.express = res.data.express.list;
          console.log(self.express);
        })
        .catch((error) => {
          self.loading = false;
        });
    },
    /*关闭弹窗*/
    dialogFormVisible() {
      this.$emit("closeDialog", { openDialog: false });
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/express/dialog/Track.vue